<p-toast [breakpoints]="{ '420px': { width: '100%', right: '0', left: '0' } }"></p-toast>
<app-loader></app-loader>
        <div class="back-outer mobile-back" routerLink="/">
  <p>Back to home</p>
</div>
<section class="main-help">
    <div class="need-help-outer" *ngIf="needHelp" (click)="toggle()">
        <div class="need-inner">
            <img src="assets/images/interogate.svg" alt="" />
            <h5>Need Help?</h5>

        </div>
    </div>
    <div class="close-popup " (click)="toggle()" [ngClass]="{'openclose': close}">

        <div class="close-btn">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.7208 0.279164C11.542 0.100415 11.2996 0 11.0467 0C10.7939 0 10.5514 0.100415 10.3726 0.279164L6 4.65179L1.62737 0.279164C1.44857 0.100415 1.2061 0 0.953269 0C0.700442 0 0.457967 0.100415 0.279164 0.279164C0.100415 0.457967 0 0.700442 0 0.953269C0 1.2061 0.100415 1.44857 0.279164 1.62737L4.65179 6L0.279164 10.3726C0.100415 10.5514 0 10.7939 0 11.0467C0 11.2996 0.100415 11.542 0.279164 11.7208C0.457967 11.8996 0.700442 12 0.953269 12C1.2061 12 1.44857 11.8996 1.62737 11.7208L6 7.34821L10.3726 11.7208C10.5514 11.8996 10.7939 12 11.0467 12C11.2996 12 11.542 11.8996 11.7208 11.7208C11.8996 11.542 12 11.2996 12 11.0467C12 10.7939 11.8996 10.5514 11.7208 10.3726L7.34821 6L11.7208 1.62737C11.8996 1.44857 12 1.2061 12 0.953269C12 0.700442 11.8996 0.457967 11.7208 0.279164Z"
                    fill="white" />
            </svg>
            <h5>Close</h5>
        </div>
        <div class="popup-text">
            <h4>Feel free to contact us anytime!</h4>
            <div class="popup-body">
                <div class="chat-outer">
                    <h5>Chat with us</h5>
                    <p>Our friendly team is here to help:</p>
                    <p>support&#64;trucklots.com</p>
                </div>
                <div class="chat-outer custom-visit">
                    <h5>Visit us</h5>
                    <p>Come say hello at our office:</p>
                    <p>40 Rahling Circle, Little Rock, AR 72223</p>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="onboarding-outer">
    <div class="landing-container">
        <div class="onboarding-banner">
            <a href="/"><img src={{logo}} alt="onboardin banner"/></a>
            <h3>Greetings from a world where every mile counts!</h3>
            <p>Thank you for your interest in Trucklots </p>
        </div>
    </div>
</section>
<section class="navigate-outer">
    <div class="landing-container">
        <div class="navigating-heading">
            <h3>Navigating the parking lot with ease</h3>
            <p>We request you to fill in the details to know more </p>
        </div>
        <div class="gen-information">
            <img src="assets/images/gen-arrow.svg" alt="" />
            <h5>General information</h5>
        </div>
        <form [formGroup]="ownerForm" class="form">
            <div class="grid">
                <div class="col-12 lg:col-3 md:col-6">
                    <div class="gen-email">
                        <label for="firstName">First Name<span class="custom-star">*</span></label>
                        <input pInputText id="firstName" maxlength="50" placeholder="Enter First Name" aria-describedby="username-help"
                            formControlName="firstName" (keydown)="dialogControlService.noNumbersValidator($event)"/>
                        <div
                            *ngIf="ownerForm.get('firstName').hasError('required') && (ownerForm.get('firstName').touched || ownerForm.get('firstName').dirty)">
                            <small class="validation-error">This field is required*</small>
                        </div>
                        <div
                            *ngIf="ownerForm.get('firstName').hasError('pattern') && (ownerForm.get('firstName').touched  || ownerForm.get('firstName').dirty)">
                            <small class="validation-error">Please enter only characters*</small>
                        </div>
                        <div
                            *ngIf="ownerForm.get('firstName').hasError('leadingSpace') && (ownerForm.get('firstName').touched  || ownerForm.get('firstName').dirty)">
                            <small class="validation-error">First Name cannot start with a space.*</small>
                        </div>
                        <div
                            *ngIf="ownerForm.get('firstName').hasError('minlength') && (ownerForm.get('firstName').touched || ownerForm.get('firstName').dirty)">
                            <small class="validation-error">Minimum 3 characters are required*</small>
                        </div>
                    </div>
                </div>
                <div class="col-12 lg:col-3 md:col-6">
                    <div class="gen-email">
                        <label for="lastName">Last Name<span *ngIf="requiredLastNameAsterisk" class="custom-star">*</span></label>
                        <input pInputText id="lastName" placeholder="Enter Last Name" aria-describedby="username-help"
                            formControlName="lastName" maxlength="50" (keydown)="dialogControlService.noNumbersValidator($event)" />
                            <div
                                *ngIf="ownerForm.get('lastName').hasError('required') && (ownerForm.get('lastName').touched || ownerForm.get('lastName').dirty)">
                                <small class="validation-error">This field is required*</small>
                            </div>
                            <div
                                *ngIf="ownerForm.get('lastName').hasError('leadingSpace') && (ownerForm.get('lastName').touched || ownerForm.get('lastName').dirty)">
                                <small class="validation-error">Last Name cannot start with a space.*</small>
                            </div>
                        <div
                            *ngIf="ownerForm.get('lastName').hasError('pattern') && (ownerForm.get('lastName').touched  || ownerForm.get('lastName').dirty)">
                            <small class="validation-error">Please enter only characters*</small>
                        </div>
                        <div
                            *ngIf="ownerForm.get('lastName').hasError('minlength') && (ownerForm.get('lastName').touched || ownerForm.get('lastName').dirty)">
                            <small class="validation-error">Minimum 3 characters are required*</small>
                        </div>
                    </div>
                </div>
                <div class="col-12 lg:col-3 md:col-6">
                    <div class="gen-email">
                        <label for="businessName">Business Name<span class="custom-star">*</span></label>
                        <input pInputText id="businessName" placeholder="Enter Business Name"
                            aria-describedby="username-help" maxlength="50" formControlName="businessName" />
                    </div>
                    <div
                        *ngIf="ownerForm.get('businessName').hasError('required') && (ownerForm.get('businessName').touched  || ownerForm.get('businessName').dirty)">
                        <small class="validation-error">This field is required*</small>
                    </div>
                    <div
                        *ngIf="ownerForm.get('businessName').hasError('maxlength') && (ownerForm.get('businessName').touched  || ownerForm.get('businessName').dirty)">
                        <small class="validation-error">Maximum length is 50 characters</small>
                    </div>
                    <div
                        *ngIf="ownerForm.get('businessName').hasError('minlength') && (ownerForm.get('businessName').touched || ownerForm.get('businessName').dirty)">
                        <small class="validation-error">Minimum 3 characters are required*</small>
                    </div>
                </div>
                <div class="col-12 lg:col-3 md:col-6">
                    <div class="gen-email">
                        <label for="email">Email<span class="custom-star">*</span></label>
                        <input pInputText id="email" placeholder="Enter Email" aria-describedby="email-help"
                            formControlName="email" />
                        <div
                            *ngIf="ownerForm.get('email').hasError('required') &&( ownerForm.get('email').touched || ownerForm.get('email').dirty)">
                            <small class="validation-error">This field is required*</small>
                        </div>
                        <div
                            *ngIf="ownerForm.get('email').hasError('pattern') && (ownerForm.get('email').touched || ownerForm.get('email').dirty)">
                            <small class="validation-error">Please enter a valid email*</small>
                        </div>
                    </div>
                </div>
                <div class="col-12 lg:col-3 md:col-6">
                    <div class="gen-email country-code">
                        <label for="phone">Mobile Number<span *ngIf="requiredLastNameAsterisk" class="custom-star">*</span></label>
                        <ngx-intl-tel-input [cssClass]="'custom'" [preferredCountries]="preferredCountries" [enableAutoCountrySelect]="true"
                            [enablePlaceholder]="true" [searchCountryFlag]="true"
                            [searchCountryField]="[searchCountryField.Iso2, searchCountryField.Name]" [selectFirstCountry]="false"
                            [selectedCountryISO]="countryISO.UnitedStates" [maxLength]="10" [phoneValidation]="true"
                            [separateDialCode]="separateDialCode" customPlaceholder="Enter Mobile Number"
                            [numberFormat]="phoneNumberFormat.National" id="phone" name="phone" formControlName="phone">
                        </ngx-intl-tel-input>
                        <div
                            *ngIf="ownerForm.get('phone').hasError('required') && ownerForm.get('phone').dirty && ownerForm.get('phone').touched">
                            <small class="validation-error">This field is required*</small>
                        </div>
                         <div *ngIf="!ownerForm.get('phone').hasError('required') && ownerForm.get('phone').touched && ownerForm.get('phone').invalid"
                                    class="validation-error">Mobile number is not valid*</div>
                    </div>
                </div>
            </div>

            <div class="gen-information share-outer">
                <img src="assets/images/gen-arrow.svg" alt="" />
                <h5>Share some more details to help us onboard your parking lot</h5>
            </div>
            <div class="grid">
                <div class="col-12 lg:col-3 md:col-6">
                    <div class="gen-email">
                        <label for="parkingCapacity">Total Parking Capacity</label>
                        <p-inputNumber id="parkingCapacity" placeholder="Enter Total Parking Capacity"
                            aria-describedby="username-help" formControlName="totalParkingSpace"></p-inputNumber>
                        <div
                            *ngIf="ownerForm.get('totalParkingSpace').hasError('pattern') && ownerForm.get('totalParkingSpace').touched && ownerForm.get('totalParkingSpace').dirty">
                            <small class="validation-error">Capacity must be more than 0</small>
                        </div>
                        <div
                            *ngIf="ownerForm.get('totalParkingSpace').hasError('lessThanThousand') && ownerForm.get('totalParkingSpace').touched && ownerForm.get('totalParkingSpace').dirty">
                            <small class="validation-error">Capacity must not exceed 999</small>
                        </div>
                    </div>

                </div>

                <div class="col-12 lg:col-9">
                    <div class="gen-main-outer">
                        <div class="gen-email series-outer">
                            <p>Do you have parking lot series?</p>
                            <div class="parking-series">
                                <p-radioButton id="yesRadioButton" [value]=true inputId="yesRadioButton"
                                    formControlName="isParkingLotSeries"></p-radioButton>
                                <label for="yesRadioButton" class="radio-label">Yes</label>
                                <p-radioButton id="noRadioButton" [value]=false inputId="noRadioButton"
                                    formControlName="isParkingLotSeries"></p-radioButton>
                                <label for="noRadioButton" class="radio-label">No</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
        <div class="management-outer">
            <p>Set out on a truck parking management journey now!</p>
        </div>
        <div class="submit-outer">
            <p-button type="submit" label="Submit" (onClick)="submit()"></p-button>
        </div>
    </div>
</section>
<section class="copy-right">
    <div class="landing-container">
        <div class="grid">
            <div class="col-12 lg:col-6 md:col-6">
                <div class="copy-email">
                    <p>support&#64;trucklots.com</p>
                </div>
            </div>
            <div class="col-12 lg:col-6 md:col-6">
                <div class="copyright-outer">
                    <p>Copyright © 2024. All rights reserved by Trucklots.</p>
                </div>
            </div>
        </div>
    </div>
</section>
